<div class="conf-summary row">
  <section class="conf-summary__col">
    <h3><span>Ihr</span> Einsatz</h3>
    <div
      class="conf-summary__rate"
      [ngClass]="{ 'conf-summary__rate--nkl': env === 'nkl' }"
    >
      {{ ticketPrice | currency : 'EUR' : 'symbol' : '1.2-2' }}
    </div>
    <small *ngIf="ticketPrice > 0"
      >zzgl.
      {{ serviceFee | currency : 'EUR' : 'symbol' : '1.2-2' }}
      Servicepauschale * inkl. gesetzl. MwSt.</small
    >
    <small *ngIf="backPay > 0"
      >zzgl. einmalige Nachzahlung von
      {{ backPay | currency : 'EUR' : 'symbol' : '1.2-2' }}

      <div class="co-icon" [attr.aria-label]="getTooltipText()">
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path
            fill="#cccccc"
            d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
          ></path>
          <circle
            fill="none"
            stroke-width="1.1"
            stroke="#cccccc"
            cx="10"
            cy="10"
            r="9"
          ></circle>
        </svg>
      </div>
    </small>
  </section>
  <section
    class="conf-summary__col"
    [ngClass]="{
      'conf-summary__col--border': maxGain > 0
    }"
  >
    <div *ngIf="maxGain > 0">
      <h3>Spitzengewinn</h3>
      <div
        class="conf-summary__rate"
        [ngClass]="{ 'conf-summary__rate--nkl': env === 'nkl' }"
        *ngIf="!pension"
      >
        {{ maxGain | millionize }}<sup *ngIf="env === 'skl'">1</sup
        ><sup *ngIf="env === 'nkl'">A</sup>
      </div>
      <div
        class="conf-summary__rate"
        [ngClass]="{ 'conf-summary__rate--nkl': env === 'nkl' }"
        *ngIf="pension"
      >
        {{ maxGain | currency : 'EUR' : 'symbol' : '1.2-2'
        }}<sup *ngIf="env === 'skl'">1</sup><sup *ngIf="env === 'nkl'">A</sup>
      </div>
      <small>bei Teilnahme an allen 6 Klassen</small>
      <small *ngIf="pension"
        >Bei Basislos: als monatliche Rente über die Dauer von 5 Jahren.
        <br />
        Bei Superlos: als monatliche Rente über die Dauer von 10 Jahren.</small
      >
    </div>
  </section>
  <section
    class="conf-summary__col"
    [ngClass]="{
      'conf-summary__col--border': odds > 0
    }"
  >
    <div *ngIf="odds > 0">
      <h3><span>Ihre</span> Trefferchance</h3>
      <div
        class="conf-summary__rate"
        [ngClass]="{ 'conf-summary__rate--nkl': env === 'nkl' }"
      >
        {{ odds }} %
      </div>
      <small *ngIf="pension"
        >Gewinnwahrscheinlichkeiten der
        {{ environment | uppercase }}-Rentenlotterie<sup *ngIf="env === 'skl'"
          >1</sup
        ><sup *ngIf="env === 'nkl'">A</sup></small
      >
      <small *ngIf="!pension"
        >Gewinnwahrscheinlichkeiten des
        {{ environment | uppercase }}-Millionenspiels<sup *ngIf="env === 'skl'"
          >1</sup
        ><sup *ngIf="env === 'nkl'">A</sup></small
      >
    </div>
  </section>
  <section class="conf-summary__col">
    <button class="uk-button uk-button-primary" (click)="goToCheckout()">
      In den Warenkorb
    </button>
  </section>
</div>
